import { Component, type ErrorInfo, type PropsWithChildren, type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNetworkStatus } from '../hooks/useNetworkStatus';
import { useAppStore } from '../store/AppStore';
import { useDemo } from '../demo/DemoProvider';
import { useDemoContext224 } from '../demo/useDemoContext224';

export function SystemBanners() {
  const online = useNetworkStatus();
  const navigate = useNavigate();
  const { error, clearError, reload, logout } = useAppStore();
  const { reset } = useDemo();
  const demo = useDemoContext224();

  // Leaving the trial has to end the demo session before it goes anywhere: a
  // link back to /demo left the visitor signed in as the demo child, and the
  // login screen would have bounced them straight back to that account. And
  // the thing to do after a trial is open an account, not pick another one.
  const leaveDemo = async () => {
    await logout();
    reset();
    navigate('/login');
  };

  return <>
    {demo.demo && <div className="global-banner demo-mode" role="status">
      <span>체험 계정입니다 · 실제 계정과 분리되어 있어요{demo.restrictedFeatures.length ? ` · 일부 기능 ${demo.restrictedFeatures.length}개 잠김` : ''}</span>
      <button type="button" className="demo-leave-2-24-5" onClick={() => void leaveDemo()}>체험 끝내고 시작하기</button>
    </div>}
    {!online && <div className="global-banner offline" role="status" aria-live="polite">오프라인 상태입니다. 모의 API에서는 로컬 기록이 유지됩니다.</div>}
    {error && <div className="global-banner error" role="alert"><span>{error}</span><button onClick={() => { clearError(); void reload(); }}>다시 시도</button></div>}
  </>;
}

export class AppErrorBoundary extends Component<PropsWithChildren, { hasError: boolean }> {
  state = { hasError: false };
  static getDerivedStateFromError() { return { hasError: true }; }
  componentDidCatch(error: Error, info: ErrorInfo) { console.error('MRM_RENDER_ERROR', error.message, info.componentStack); }
  render(): ReactNode {
    if (this.state.hasError) return <main className="app-shell"><section className="phone-frame"><div className="system-state"><strong>화면을 표시하지 못했습니다</strong><p>새로고침 후 다시 시도해 주세요.</p><button className="primary-button" onClick={() => location.reload()}>새로고침</button></div></section></main>;
    return this.props.children;
  }
}
